// Base module
angular.module('SEVENBase', []);

angular
    .module('SEVENBase')
    .controller(
        'SEVENBaseCtrl',
        ['$log', '$injector', '$scope', '$rootScope', '$window', '$document', '$location', '$state', '$sce', '$timeout', 'locker', 'SEVENUser', 'SEVENConfig', 'SEVENSettings', 'SEVENModules', 'SEVENLocale', 'SEVENArticles', 'SEVENActiveGames', 'SEVENIntegrator', 'SEVENPlayerService', 'SEVENPlayerAuthService', 'SEVENModalSvc', 'SEVENOddTypeService', 'SEVENOddsOptionService', 'SEVENTimezoneService', 'SEVENRouteService', 'SEVENCmsService', 'SEVENSocket', 'SEVENSentry', 'SEVENNotifier', 'SEVENNotificationsPusherService', 'SEVENBanners', 'SEVENHelpers', 'SevenGravitySettings', 'SEVENUiService', 'SEVENLegalEntitiesService', function (
            $log,
            $injector,
            $scope,
            $rootScope,
            $window,
            $document,
            $location,
            $state,
            $sce,
            $timeout,
            locker,
            SEVENUser,
            SEVENConfig,
            SEVENSettings,
            SEVENModules,
            SEVENLocale,
            SEVENArticles,
            SEVENActiveGames,
            SEVENIntegrator,
            SEVENPlayerService,
            SEVENPlayerAuthService,
            SEVENModalSvc,
            SEVENOddTypeService,
            SEVENOddsOptionService,
            SEVENTimezoneService,
            SEVENRouteService,
            SEVENCmsService,
            SEVENSocket,
            SEVENSentry,
            SEVENNotifier,
            SEVENNotificationsPusherService,
            SEVENBanners,
            SEVENHelpers,
            SevenGravitySettings,
            SEVENUiService,
            SEVENLegalEntitiesService
        ) {
            var user = SEVENUser,
                config = SEVENConfig,
                settings = SEVENSettings,
                modules = SEVENModules,
                locale = SEVENLocale,
                articles = SEVENArticles,
                integrator = SEVENIntegrator,
                playerService = SEVENPlayerService,
                playerAuthService = SEVENPlayerAuthService,
                modalService = SEVENModalSvc,
                oddTypeService = SEVENOddTypeService,
                oddsOptionService = SEVENOddsOptionService,
                timezoneService = SEVENTimezoneService,
                cmsService = SEVENCmsService,
                routeService = SEVENRouteService,
                socketPromise = SEVENSocket,
                notifier = SEVENNotifier,
                notificationsPusher = SEVENNotificationsPusherService,
                banners = SEVENBanners,
                helpers = SEVENHelpers,
                appSettings = SevenGravitySettings,
                uiService = SEVENUiService,
                legalEntitiesService = SEVENLegalEntitiesService,
                authModuleSettings = appSettings.getDataByKey('module.authAndPlayer'),
                socket,
                seoPages = appSettings.getDataByKey('seo.pages'),
                SEVENZendesk = false,
                pusher,
                firstStateChanged = false,
                currentAutomaticTitle = null,
                titleSeparator;

            // Keep subscribed flag
            var subscribedToPlayer = false,
                subscribedToPusherNotifications = false;

            // Initialize
            var init = function () {
                checkForStaleFileVersions();
                // probably there is more elegeant way in future in
                // order to completly remove SEVENZendesk injection
                if ($injector.has('SEVENZendesk')) {
                    SEVENZendesk = $injector.get('SEVENZendesk');
                }

                // Bind scope
                $scope.$state = $state;
                $scope.config = config;
                $scope.settings = settings;
                $scope.locale = locale;
                $scope.footerTemplate = modules.directives.footer;
                $scope.betslipBetCount = 0;
                $scope.activeTicketsCount = 0;
                $scope.activeProduct = false;
                $scope.productOddTypes = false;
                $scope.oddType = oddTypeService.getDefaultOddType($scope.productOddTypes);
                $scope.hasSupport = !!SEVENZendesk;
                $scope.clockFormat = helpers.getResponsiveTag() === 'min' ? 'LTS' : 'L LTS';
                $scope.sidebarExpanded = false;
                $scope.isPrivateBrowsingMode = $window.isPrivateBrowsingMode;
                $scope.isCookieBlocked = !locker._supported;
                $scope.uiState = uiService.uiState;
                $scope.isSeoDescActive = false;
                $rootScope.supportedImageFormat = window.supportedImageFormat;
                $scope.shouldHideHeader = false;

                // Remove language switch - in standalone mode only
                if (settings.mode !== 'integration') {
                    $location.search('lang', null);
                }
                // Request notify rights
                notifier.grant();
                // Set language
                setLanguage();
                setPlayerOddsOption();
                setPlayerTimezone();
                // Set all active games
                SEVENActiveGames.init();
                // Bind document events
                bindDocumentEvents();
                checkModalBanner();
                setFooterPaymentSectionContent();
                setFooterLegalImage();
                showLoginModalIfRedirectUrl();
                setPullToRefreshListeners();
            };

            var setSEODescription = function (data) {
                $scope.isSeoDescActive =
                    data &&
                    data.seoDescription &&
                    data.seoArticle &&
                    articles.includes(data.seoArticle);

                $scope.setSeoData = data;

                $timeout(function () {
                    $scope.seoDescription = false;
                    $scope.isSeoDescExpanded = false;
                }, 0);
            };

            var checkRegisterDialogNative = function () {
                var isRegisterDialog = $location.search().registerDialog;
                var formData = locker.get('RegisterFormData');

                if (isRegisterDialog && settings.nativeMode && formData) {
                    modalService
                        .showModal({
                            templateUrl: $state.current.data.dialogTemplate,
                            controller: 'SEVENPlayerRegisterDialogCtrl',
                            controllerAs: 'register',
                        })
                        .then(function (modal) {
                            modal.element.show();
                        });
                }
            };

            var setFooterPaymentSectionContent = function () {
                var footerArticleExists = articles.includes('footer_payment');
                if (!footerArticleExists) return;
                cmsService
                    .getArticle('footer_payment')
                    .then(function (response) {
                        $scope.paymentSectionContent = $sce.trustAsHtml(
                            response.data.article.content
                        );
                    })
                    .catch(function () {
                        $log.debug("footer_payment article doesn't exist for company");
                    });
            };

            var setFooterLegalImage = function () {
                if (!settings.footer.legalImage) return;
                var externalAssets = settings.api.assets.url[settings.server];
                var externalAssetsCompany =
                    externalAssets + '/' + settings.company.name + '/7web_assets-images';

                $scope.legalImageBaseSrc = externalAssetsCompany + `/legal`;
            };

            var setPullToRefreshListeners = function () {
                $rootScope.$on('SEVEN.TogglePullToRefresh', function (event, enabled) {
                    $rootScope.disablePullToRefresh = !enabled;
                });
            };
            var checkModalBanner = function () {
                var banner = banners.getModalBanner();
                var bannerName = (banner && banner.trackName) || 'ModalBanner';
                var bannerShown = locker.get(bannerName, 0);
                var showOnMobile = settings.isMobile
                    ? !settings.banners.disableMobileModalBanner
                    : true;

                if (
                    banner &&
                    banner.modalUrl &&
                    (!banner.showLimit || bannerShown < banner.showLimit) &&
                    showOnMobile
                ) {
                    modalService
                        .showModal({
                            templateUrl: banner.modalUrl,
                            controller: [
                                '$scope',
                                'close',
                                function (scope, close) {
                                    locker.put(bannerName, bannerShown + 1);
                                    scope.close = close;
                                },
                            ],
                        })
                        .then(function (modal) {
                            modal.element.show();
                        });
                }
            };

            var subscribeToPusherNotifications = function () {
                // NOTE: Player channel name convention: 'private-{$companyUuid}-player-{$playerUuid}'
                var playerChannelName = 'private-' + settings.company.id + '-player-' + user.id,
                    playerChannel;

                // Initialise Pusher
                pusher = notificationsPusher.init();

                if (pusher) {
                    playerChannel = pusher.subscribe(playerChannelName);

                    // Set subscription flag
                    subscribedToPusherNotifications = !!playerChannel;

                    playerChannel.bind('Player.Notify', function (message) {
                        var DEFLATE_BASE64_PAYLOAD_ENCODING = 'deflate';

                        if (
                            message &&
                            message.payloadEncoding === DEFLATE_BASE64_PAYLOAD_ENCODING
                        ) {
                            try {
                                message.payload = JSON.parse(
                                    pako.inflate(window.atob(message.payload), {
                                        to: 'string',
                                    })
                                );
                            } catch (e) {
                                SEVENSentry.captureException(e);
                                $log.error(
                                    '[Seven] Pusher:Player.Notify: Payload decompression error',
                                    e
                                );
                            }
                        }

                        $log.log('[Seven] Pusher:Player.Notify: message => ', message);

                        $scope.notificationPusher = message;
                    });
                }
            };

            var unsubscribeFromPusher = function () {
                if (pusher) {
                    pusher.disconnect();
                    subscribedToPusherNotifications = false;
                }
            };

            // Subscribe to player socket
            var subscribeToPlayerSocket = function () {
                // Resolve socket promise
                socketPromise.then(function (socketInstance) {
                    // Create new socket instance
                    socket = socketInstance();
                    // Forward events
                    socket.forward(user.id, $scope);
                    socket.forward('connect', $scope);

                    // Listen to player events
                    $scope.$on('SEVEN:' + user.id, function (event, response) {
                        // Check type
                        switch (response.type) {
                            case 'balanceUpdate':
                                if (
                                    !integrator.isBalanceChangedListenerActive() &&
                                    !settings.api.listeners.updateBalance
                                ) {
                                    user.getThrottledBalance();
                                }

                                if (
                                    settings.mode === 'integration' &&
                                    settings.api.listeners.updateBalance
                                ) {
                                    user.fillBalance(response.data);
                                }
                                break;
                            case 'loginRequired':
                                $rootScope.$broadcast('SEVEN.PlayerLogout');
                                break;
                            case 'playerActivityAlert':
                                // Get login time
                                var time = response.sentTime;
                                if (response.data.lastLogin && response.data.lastLogin.date) {
                                    time = response.data.lastLogin.date;
                                }

                                // Notify player
                                notifier.notify(
                                    config.messages.general.playerActivityAlert.supplant({
                                        time: moment(time).format('lll'),
                                    }),
                                    null,
                                    'default'
                                );

                                break;
                        }
                    });

                    // Set subscription flag
                    subscribedToPlayer = true;
                });
            };

            // Unsubscribe from player socket
            var unsubscribeFromPlayerSocket = function () {
                if (socket) {
                    socket.emit('unsubscribe');
                    socket.disconnect();
                    subscribedToPlayer = false;
                }
            };

            // Flash betslip button
            var flashBetslipButton = function () {
                var selector = $('.n-options .betslip'),
                    changeClass = 'changed';

                clearInterval(window.betslipButtonInterval);
                selector.removeClass(changeClass);

                var count = 0;
                window.betslipButtonInterval = setInterval(function () {
                    selector.toggleClass(changeClass);
                    count += 1;
                    if (count > 3) {
                        clearInterval(window.betslipButtonInterval);
                    }
                }, 200);
            };

            // Reset general oddType setting
            var resetPlayerOddType = function () {
                var queryParam = $location.search().odds;

                $scope.oddType = oddTypeService.getPlayerOddType(
                    queryParam,
                    $scope.activeProduct,
                    $scope.productOddTypes
                );
                // Update general oddType setting and local settings
                if (user && user.settings) {
                    user.settings.oddType = $scope.oddType.id;
                    user.saveLocal();
                }
            };

            var setPlayerOddsOption = function () {
                var queryParam = $location.search().oddsChange;
                // Set User oddsOptions profile property if user is logged;
                // for integration clients only
                if (settings.mode === 'integration' && user && user.profile) {
                    oddsOptionService.setPlayerOddsOption(queryParam);
                }
            };

            var setPlayerTimezone = function () {
                var timezone = $location.search().timezone;

                if (settings.mode === 'integration' && user && user.profile) {
                    timezoneService.setPlayerTimezone(timezone);
                }
            };

            // Set language
            var setLanguage = function (value) {
                $rootScope.language = locale.getActiveLanguageDetails(value);
            };

            // If there is a redirectUrl on $rootScope show login modal
            var showLoginModalIfRedirectUrl = function () {
                if ($rootScope.redirectUrl) {
                    var unwatch = $scope.$watchGroup(
                        ['user.logged', 'user.id'],
                        function (newValues) {
                            if (newValues[0] === false && newValues[1] === null) {
                                $location.search({ initShowLogin: true });
                                unwatch();
                            } else if (newValues[0] === true) {
                                unwatch();
                            }
                        }
                    );
                }
            };

            // Bind document element
            var bindDocumentEvents = function () {
                // Bind scroll event to emit to parent
                if (settings.api.events.scroll) {
                    angular.element(document).on('scroll', function (event) {
                        var target = angular.element(event.currentTarget),
                            position = {
                                top: target.scrollTop(),
                                left: target.scrollLeft(),
                            };

                        // Broadcast to children
                        $rootScope.$broadcast('SEVEN.Scrolling', position);

                        // Emit to parent
                        if (settings.mode === 'integration') {
                            integrator.sendMessage({
                                type: 'scroll',
                                data: position,
                            });
                        }
                    });
                }

                // Bind click event and stopped clicks emit to parent
                if (settings.mode === 'integration' && settings.api.events.click) {
                    angular.element(document).on('click', sendClickMessageToIntegrator);
                    $rootScope.$on('Seven.StoppedClick', sendClickMessageToIntegrator);
                }

                if (authModuleSettings.loginCheckOnDocumentVisible) {
                    $window.addEventListener('visibilitychange', function logData() {
                        if (document.visibilityState === 'visible') {
                            if (user.id) playerAuthService.loginCheck().catch(angular.noop);
                        }
                    });
                }

                $window.addEventListener(
                    'orientationchange',
                    function () {
                        $document.triggerHandler('click');
                    },
                    false
                );

                window.addEventListener('online', function () {
                    if (user.logged) user.getThrottledBalance();
                });
            };

            var sendClickMessageToIntegrator = function () {
                integrator.sendMessage({
                    type: 'click',
                });
            };

            // Send user info on support provider
            var registerPlayerToSupport = function () {
                if ($scope.hasSupport) {
                    SEVENZendesk.getImplementation().registerPlayerToSupport({
                        language: locale.activeLanguage,
                    });
                }
            };

            // Update player on support
            var updatePlayerToSupport = function () {
                if ($scope.hasSupport) {
                    SEVENZendesk.getImplementation().updatePlayerToSupport();
                }
            };

            var setExclusionOverlay = function () {
                var exclusion = $state.current.data.exclusion || $state.current.name;
                var selfExcludedProducts = user.profile && user.profile.selfExcludedProducts;

                $scope.excludedProduct = Array.isArray(selfExcludedProducts)
                    ? selfExcludedProducts.find(function (excludedProduct) {
                          return excludedProduct.product === exclusion;
                      })
                    : null;
            };

            $scope.toggleSeoDescription = function () {
                $scope.isSeoDescExpanded = !$scope.isSeoDescExpanded;
            };

            $scope.showSEODescription = function () {
                $scope.seoDescription = true;
            };

            // Toggle odds list
            $scope.toggleOddTypes = function (close) {
                $scope.activeOddType = close ? false : !$scope.activeOddType;
            };

            // Change odd type per product
            $scope.changeOddType = function (item) {
                var product = $scope.activeProduct,
                    propertyKey = product + '_oddType',
                    namespacedKey = 'product.' + propertyKey;

                // Update selected oddType
                $scope.oddType = item;
                // Set general oddType
                user.settings.oddType = item.id;
                // Set product oddType
                user.settings[propertyKey] = item.id;

                // Persist oddType as User setting and save locally
                if (user.logged && product) {
                    user.saveSetting(namespacedKey, user.settings[propertyKey], 'number').then(
                        function () {
                            user.saveLocal();
                        }
                    );
                } else {
                    // Save locally for Guest user
                    user.saveLocal();
                }
            };

            /**
             * Toggle sidebar and emit state change to other components
             *
             * @fires SEVEN.ToggleSidebar
             * @param {Boolean} [close]
             */
            $scope.toggleSidebar = function (close, stopPropagation) {
                var element = $('.n-sidebar'),
                    data = {},
                    expanded = 'expanded';

                if (close) {
                    if (element.hasClass(expanded)) {
                        element.removeClass(expanded);
                    }
                    $scope.sidebarExpanded = false;
                } else {
                    element.toggleClass(expanded);
                    $scope.sidebarExpanded = !$scope.sidebarExpanded;
                }

                data.isVisible = $scope.sidebarExpanded;

                // only emit show property if close flag is
                // explicitly set to some value
                if (angular.isDefined(close)) {
                    data.show = !close;
                }

                if (stopPropagation) return;

                /**
                 * Event reporting that a sidebar visible state has been changed.
                 *
                 * @event SEVEN.ToggleSidebar
                 * @type {Object}
                 * @property {Boolean} [show] - Indicates whether the sidebar is showen.
                 */
                $scope.$emit('SEVEN.ToggleSidebar', data);
                setBodyScrollability();
            };

            // Close sidebar
            $scope.closeSidebar = function () {
                $scope.sidebarExpanded = false;
                $scope.toggleSidebar(true);
            };

            /**
             * Emit change to other components
             *
             * @fires SEVEN.ShowLastTickets
             */
            $scope.showLastTickets = function () {
                $scope.$emit('SEVEN.ShowLastTickets');
            };

            /**
             * Emit change to other components
             *
             * @fires SEVEN.ShowBettingArea
             */
            $scope.showBettingArea = function () {
                $scope.$emit('SEVEN.ShowBettingArea');
            };

            // Change language
            $scope.changeLanguage = function (item) {
                // Set language item
                $rootScope.language = item;

                if (!user.logged) {
                    locale.updateLanguageChange(item.value);
                    return;
                }

                // Persist player setting
                playerService
                    .updateProfilePart({
                        language: item.value,
                    })
                    .then(function () {
                        user.fillProfile(true).catch(angular.noop);
                    });
            };

            var setPlayerHistoryState = function () {
                $scope.playerHistoryState = playerService.getPlayerHistoryState();
            };

            var setBottomMenuVisibility = function (state) {
                // state prototypically inherits data from all parents. This enables flexibility to set visibility on parent
                // state. All child will have same menu visibility. Visibility can also be set for child to override parent setting
                $scope.mobileBottomMenuActive = state && state.data && state.data.mobileBottomMenu;
            };

            var setBodyScrollability = function () {
                if (uiService.uiState.fixed) return;

                $rootScope.disableBodyScroll = Boolean($scope.sidebarExpanded || $scope.overlay);
            };

            var applyZopimSettings = function () {
                SEVENZendesk.init({
                    language: $rootScope.language.value,
                });
            };

            var findSEOPage = function () {
                if (!seoPages) return null;

                const pathSeparator = '/';
                const currentPath = window.decodeURIComponent($location.path());
                const currentPathSeoPage =
                    seoPages[currentPath] && seoPages[currentPath][locale.activeLanguage];
                const firstLevelPath = pathSeparator + currentPath.split(pathSeparator)[1];
                const firstLevelPathSeoPage =
                    seoPages[firstLevelPath] && seoPages[firstLevelPath][locale.activeLanguage];
                const rootPath = pathSeparator;
                const rootLevelPathSeoPage =
                    seoPages[rootPath] && seoPages[rootPath][locale.activeLanguage];
                const upperLevelSeoPage = firstLevelPathSeoPage || rootLevelPathSeoPage;

                if (currentPathSeoPage) {
                    return currentPathSeoPage;
                } else if (!currentAutomaticTitle && upperLevelSeoPage) {
                    return upperLevelSeoPage;
                } else {
                    return null;
                }
            };

            var formatBreadcrumbTitle = function (breadcrumbTrail) {
                if (!breadcrumbTrail || breadcrumbTrail.length < 0) return;

                var title = '';

                breadcrumbTrail.forEach(function (item) {
                    title += item + titleSeparator;
                });

                title += $state.current.data.title + titleSeparator + config.client.name;

                return title;
            };

            var findClosestBackgroundImage = function (breakpoints) {
                var currentWidth = $window.innerWidth;
                var min = Math.min();
                var imageSrc = '';
                angular.forEach(breakpoints, function (breakpoint, key) {
                    var absDiff = Math.abs(currentWidth - key);

                    if (min < absDiff) return;

                    min = absDiff;
                    imageSrc = breakpoint.src;
                });

                return imageSrc;
            };

            var checkPagesForBackground = function (data, params) {
                if (!data.page) {
                    setBackgroundImage();
                    return;
                }

                var cmsPageName = params && params.name ? data.page + '_' + params.name : data.page;

                cmsService
                    .getPageByName(cmsPageName)
                    .then(function (response) {
                        var hasPageBackground =
                            response.data &&
                            response.data.page &&
                            response.data.page.active &&
                            response.data.page.customData &&
                            response.data.page.customData.background;

                        var backgroundImageSrc = null;

                        if (hasPageBackground) {
                            backgroundImageSrc = findClosestBackgroundImage(
                                response.data.page.customData.background
                            );
                        }

                        setBackgroundImage(backgroundImageSrc);
                    })
                    .catch(function () {
                        setBackgroundImage();
                    });
            };

            var setBackgroundImage = function (src) {
                var bgStyle = {
                    'background-image': 'none',
                };

                if (src) {
                    bgStyle = {
                        'background-image': 'url(' + src + ')',
                        'background-attachment': 'fixed',
                        'background-size': 'cover',
                    };
                }

                $rootScope.contentStyle = bgStyle;
            };

            // Toggle support
            $scope.toggleSupport = function (message) {
                if (!SEVENZendesk.isInitialized) {
                    applyZopimSettings();
                    return;
                }

                SEVENZendesk.getImplementation().toggleSupport(message);
            };

            // Ticket changed listener
            $scope.$on('SEVEN.TicketChanged', function (event, data) {
                if (data) {
                    if ($scope.betslipBetCount !== data.betCount) {
                        $scope.betslipBetCount = data.betCount;
                        flashBetslipButton();
                    }
                }
            });

            // Menu events
            $scope.$on('SEVEN.MenuChanged', function (event, expanded) {
                $scope.overlay = expanded;
                $scope.overlayHeader = expanded;
                setBodyScrollability();
            });

            // Listen on state loading event
            $scope.$on('SEVEN.StateLoading', function (event, loading) {
                $scope.stateLoading = loading;
            });

            // Listen on state loading event
            $scope.$on('SEVEN.ToggleFullWidth', function (event, isFullWidth) {
                $scope.fullWidth = isFullWidth;
            });

            // Listen on player logout
            $scope.$on('SEVEN.PlayerLogout', function () {
                if (playerAuthService.isDeAuthInProgress()) return;

                // Allow a moment for player closure to display necessary messages
                var timeoutDuration = $state.current.name === 'PlayerAccountClosure' ? 4000 : 0;
                var requireLogin = $state.current.data && $state.current.data.requireLogin;

                $timeout(function () {
                    playerAuthService
                        .logout()
                        .then(function (loggedOut) {
                            if (loggedOut) {
                                user.removeLocal();
                                user.reset();
                                user.resetSettings();
                                user.saveLocal();
                                setExclusionOverlay();

                                if (
                                    settings.company.legalEntities &&
                                    settings.company.legalEntities.length
                                ) {
                                    legalEntitiesService.goToDefaultUnauthorizedEntity();
                                }

                                if (requireLogin && requireLogin.enabled) {
                                    $state.go(requireLogin.unauthorizedState);
                                }
                            }
                        })
                        .catch(angular.noop);
                }, timeoutDuration);
            });

            // Listen on round finish event
            $scope.$on('SEVEN.RoundFinished', function (event, data) {
                integrator.sendMessage({
                    type: 'roundFinished',
                    data: data,
                });
            });

            // Listen on round finish event
            $scope.$on('SEVEN.RoundStarted', function (event, data) {
                integrator.sendMessage({
                    type: 'roundStarted',
                    data: data,
                });
            });

            // Player exclusion  listeners
            //
            // Set exclusions when user does login
            $scope.$on('SEVEN.ToggleExclusionOverlay', function (event, excludedProduct) {
                $scope.excludedProduct = excludedProduct;
            });
            $scope.$on('SEVEN.PlayerProfileChange', setExclusionOverlay);

            // Listen on ui router state change start
            $scope.$on('$stateChangeStart', function (event) {
                var skip =
                    ($state.current.data && $state.current.data.loader === false) ||
                    event.defaultPrevented;
                $scope.stateLoading = !skip;

                // Remember "odds" and "oddsChange" query parameters (if they exist)
                // in order to persist them on $stateChangeSuccess
                if (settings.mode === 'integration') {
                    routeService.saveQueryParams(['odds', 'oddsChange']);
                }
                routeService.saveQueryParams(['registerDialog']);
                // Reset activeProduct
                $scope.activeProduct = false;
            });

            // Listen on ui router state change end
            $scope.$on(
                '$stateChangeSuccess',
                function (event, toState, toParams, fromState, fromParams) {
                    // Define variables
                    var scrollSpeed = 600;

                    // Why persist "odds" param?
                    // Because "SEVEN.ProductOddTypes" event gets fired on each in-product state change
                    // (i.e. when navigating from Overview to Event view on Live)
                    // and it calls resetPlayerOddType().
                    // Why persist "oddsChange" param?
                    // On in-product state change (i.e. when navigating from Overview to Event view on Live)
                    // player's oddsOption will not reset.
                    // But if user refreshes page after that, "base" ctrl's init() will be called,
                    // and setPlayerOddsOption() will set player's "oddsOptions" to default one.
                    if (settings.mode === 'integration') {
                        // Persist "odds" and "oddsChange" query parameters
                        routeService.applyQueryParams(['odds', 'oddsChange']);
                    }
                    routeService.applyQueryParams(['registerDialog']);

                    setSEODescription(toState.data);

                    checkPagesForBackground(toState.data, toParams);

                    if (!toParams.disableStateScrollToTop) {
                        // Check if embeded
                        if ('parentIFrame' in window) {
                            window.parentIFrame.scrollTo(0, 0);
                        } else {
                            // Go to top of the page
                            $('html, body, .content-frame').animate(
                                {
                                    scrollTop: 0,
                                },
                                scrollSpeed
                            );
                        }
                    }

                    $rootScope.$broadcast('SEVEN.ResetMeta');
                    $rootScope.$broadcast('SEVEN.ResetTitle');

                    titleSeparator =
                        toState.data.titleTagSeparator || settings.company.seo.titleTagSeparator;

                    // Update ticket history state
                    setPlayerHistoryState();

                    setBottomMenuVisibility(toState);

                    // Update path on support
                    window.setTimeout(updatePlayerToSupport, 2000);

                    checkRegisterDialogNative();

                    if (toState !== fromState || !angular.equals(toParams, fromParams)) {
                        showHiddenUIElements();
                    }

                    if (!firstStateChanged) {
                        $rootScope.$broadcast('SEVEN.SetSEO');
                        firstStateChanged = true;
                    }
                }
            );

            var showHiddenUIElements = function () {
                $scope.shouldHideHeader = false;
                $scope.seoDescription = $scope.isSeoDescActive;
            };

            // Conect to player socket
            $scope.$on('SEVEN:connect', function () {
                socket.emit('subscribe', {
                    channel: user.id,
                    subChannels: {
                        language: locale.activeLanguage,
                        deliveryPlatform: settings.platform.delivery,
                    },
                });
            });

            // Receive product supported odd types
            $scope.$on('SEVEN.ProductOddTypes', function (event, data) {
                if (data) {
                    $scope.activeProduct = data.product;
                    $scope.productOddTypes = data.oddTypes;

                    // Reset odd type
                    resetPlayerOddType();
                }
            });

            $scope.$on('SEVEN.SetMeta', function (event, data) {
                if (data.name === 'description') {
                    $rootScope.meta.description.seoMeta = data.content;
                }
            });

            // Reset meta to route description
            $scope.$on('SEVEN.ResetMeta', function () {
                if ($rootScope.meta.description.seoMeta) {
                    delete $rootScope.meta.description.seoMeta;
                }
            });

            $scope.$on('SEVEN.SetTitle', function (event, data) {
                if (!data) return;

                if (data.type === 'article') {
                    currentAutomaticTitle = data.title + titleSeparator + config.client.name;
                } else {
                    currentAutomaticTitle = data.titleBreadcrumbTrail
                        ? formatBreadcrumbTitle(data.titleBreadcrumbTrail)
                        : data.title;
                }

                $rootScope.$broadcast('SEVEN.SetSEO');
            });

            $scope.$on('SEVEN.ResetTitle', function () {
                currentAutomaticTitle = null;
                $rootScope.seoPage = null;
            });

            $scope.$on('UI.Show', function (event, data) {
                if (data.name.includes('All')) {
                    showHiddenUIElements();
                }
            });

            $scope.$on('UI.Hide', function (event, data) {
                if (data.name.includes('All')) {
                    $scope.shouldHideHeader = true;
                    $scope.seoDescription = false;
                }
            });

            $rootScope.$on('SEVEN.SetSEO', function () {
                if (!seoPages && !currentAutomaticTitle) return;

                const seoPage = findSEOPage();

                if (seoPage) {
                    $rootScope.seoPage = seoPage;
                    $rootScope.meta.description.seoPage = seoPage.description;
                } else {
                    delete $rootScope.meta.description.seoPage;

                    $rootScope.seoPage = { title: currentAutomaticTitle };
                }
            });

            // Watch failed tickets
            $rootScope.$on('locker.item.updated', function (e, payload) {
                if (payload && payload.key === 'FailedTicketCount' && $scope.hasSupport) {
                    var supportData = SEVENZendesk.getSettings();
                    if (
                        supportData &&
                        supportData.triggers &&
                        supportData.triggers.failedTicketsCount
                    ) {
                        if (payload.newValue > supportData.triggers.failedTicketsCount) {
                            var message = config.messages.support.failedTicketsMessage;
                            $scope.toggleSupport(message);
                            $log.warn('Triggered support =>', message);
                        }
                    }
                }
            });

            // Watch login change
            $scope.$watch(
                function () {
                    return user.logged;
                },
                function (current, previous) {
                    // Check status
                    if (current) {
                        var postLoginState = locker.get('PostLoginState');
                        var selectedLegalEntityId =
                            legalEntitiesService.getSelectedLegalEntity() &&
                            legalEntitiesService.getSelectedLegalEntity().id;

                        if (!subscribedToPlayer) subscribeToPlayerSocket();
                        if (!subscribedToPusherNotifications) subscribeToPusherNotifications();
                        if (window.FS) {
                            window.FS.identify(user.id, {
                                displayName: user.id,
                                email: user.email,
                            });
                        }
                        window.setTimeout(registerPlayerToSupport, 30000);
                        notifier.sendUserTags();
                        $rootScope.$broadcast('SEVEN.UserLogin', true);

                        if (
                            postLoginState &&
                            (!selectedLegalEntityId || selectedLegalEntityId === config.client.uuid)
                        ) {
                            $state
                                .go(postLoginState.name, postLoginState.params)
                                .finally(function () {
                                    locker.forget('PostLoginState');
                                });
                        }
                    } else {
                        if (previous) {
                            // Unubscribe to player socket
                            unsubscribeFromPlayerSocket();
                            // Unubscribe from Pusher Player channel
                            unsubscribeFromPusher();
                            // End FullStory
                            if (window.FS) window.FS.clearUserCookie();
                            // Logout from chat
                            if ($scope.hasSupport) {
                                SEVENZendesk.getImplementation().onUserLogout();
                            }
                            // Notify logout
                            notifier.deleteUserTags();
                            $rootScope.$broadcast('SEVEN.UserLogin', false);
                        }
                    }
                }
            );

            var checkForStaleFileVersions = function () {
                if (!angular.isObject(modules.fileMap)) return;

                var appJSFile = modules.fileMap['js/app.js'];
                var dependenciesJSFile = modules.fileMap['js/dependencies.js'];

                if (appJSFile && dependenciesJSFile) {
                    var $scriptElements = document.querySelectorAll('script[src]');
                    var savedStaleVersionInfo = locker.get('VersionMismatch');
                    var appJSRegex = /js\/app\.(.*)\.js/;
                    var dependenciesJSRegex = /js\/dependencies\.(.*)\.js/;
                    var versionInfo = {
                        appJSMismatch: false,
                        dependenciesJSMismatch: false,
                    };

                    angular.forEach($scriptElements, function ($scriptElement) {
                        if (
                            $scriptElement.src.match(appJSRegex) &&
                            !$scriptElement.src.includes(appJSFile)
                        ) {
                            versionInfo.appJSMismatch = true;
                        } else if (
                            $scriptElement.src.match(dependenciesJSRegex) &&
                            !$scriptElement.src.includes(dependenciesJSFile)
                        ) {
                            versionInfo.dependenciesJSMismatch = true;
                        }
                    });

                    if (
                        !savedStaleVersionInfo &&
                        (versionInfo.appJSMismatch || versionInfo.dependenciesJSMismatch)
                    ) {
                        $log.debug('[SEVEN] Files version mismatch detected, reloading');
                        locker.put('VersionMismatch', versionInfo);
                        window.location.reload();
                    } else if (
                        savedStaleVersionInfo &&
                        (versionInfo.appJSMismatch || versionInfo.dependenciesJSMismatch)
                    ) {
                        $log.debug(
                            '[SEVEN] Files version mismatch, not reloading to prevent infinite reloads since VersionMismatch exists in local storage and app already reloaded'
                        );
                    } else {
                        locker.forget('VersionMismatch');
                    }
                }
            };

            // Watch user settings change (login/logout action) and reset odd type and odd option
            $scope.$watch(
                function () {
                    return user.settings;
                },
                function (current, previous) {
                    if (!angular.equals(current, previous)) {
                        resetPlayerOddType();
                        setPlayerOddsOption();
                        setPlayerTimezone();
                    }
                },
                true
            );

            // Set odd type after login
            $scope.$watch(
                function () {
                    return user.profile && user.profile.oddsOptions;
                },
                function (currentOddsOption, previousOddsOption) {
                    if (currentOddsOption !== previousOddsOption) {
                        setPlayerOddsOption();
                    }
                }
            );

            $scope.$watch(
                function () {
                    return user.profile && user.profile.timezone;
                },
                function (timezone, previousTimezone) {
                    if (timezone !== previousTimezone) {
                        setPlayerTimezone();
                    }
                }
            );

            // Initialize
            init();
        }]
    );
